import { createI18n } from 'vue-i18n';
import { getKeyStr ,removeKey, setKey, setKeyJsonStr ,getKeyJson,updateKeyJson,getsubKey, removeKeys} from 'd3components/src/utils/localStorage';


export function loadLang() {
  const modules: Record<string, any> = import.meta.glob('./lang/*.ts', { eager: true });
  const langs: Record<string, any> = {};

  for (const path in modules) {
    const name = path.replace(/(\.\/lang\/|\.ts)/g, '');
    langs[name] = modules[path].lang;
  }
  return langs;
}

const getStoredLocale = () => {
  // 还未登录情况下
   const visitorLang = getsubKey('mobile','visitor_lang');
  if (visitorLang) return visitorLang;
  const history = getsubKey('mobile', 'user_info');
  if (Array.isArray(history) && history[0]?.lang) {
    return history[0].lang;
  }
  return undefined;
};

const defaultLocale = getStoredLocale() || 'zh-cn';

export const i18n = createI18n({
  // globalInjection: true,
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'zh-cn',
  messages: loadLang(),
});

export function setLang(locale?: string) {
  const nextLocale = locale || getStoredLocale() || defaultLocale;
  i18n.global.locale.value = nextLocale;
  try {
    const history = getsubKey('mobile', 'user_info');
    if (Array.isArray(history) && history.length) {
      history[0] = { ...history[0], lang: nextLocale };
      updateKeyJson('mobile', 'user_info', history.slice(0, 10));
    } else {
      // 未登录 → 把语言存到 visitor_lang
      updateKeyJson('mobile','visitor_lang', nextLocale);
    }
  } catch (e) {
    console.warn('更新语言失败', e);
  }
}
